import { lightingSchema, type LightingProfile } from './lighting-profile';
import { z } from 'zod';

const savedSchema = z.strictObject({ version: z.literal(1), profile: lightingSchema });
type StorageAccess = Pick<Storage,'getItem'|'setItem'|'removeItem'>;
/** Browser-only, world/room-scoped preferences, including a storage-free session cache. */
export class LightingOverrides {
  private values = new Map<string,LightingProfile | null>();
  constructor(private storage?: StorageAccess) {}
  private key(world: string, room: string): string { return `offworld.lighting.v1:${encodeURIComponent(world)}:${encodeURIComponent(room)}`; }
  get(world: string, room: string): LightingProfile | null {
    const key = this.key(world,room);
    if (!this.values.has(key)) {
      let profile: LightingProfile | null = null;
      try { profile = savedSchema.parse(JSON.parse((this.storage ?? localStorage).getItem(key) ?? 'null')).profile; } catch { /* Follow the room for absent/invalid preferences. */ }
      this.values.set(key,profile);
    }
    return this.values.get(key)!;
  }
  set(world: string, room: string, profile: LightingProfile | null): boolean {
    const key = this.key(world,room), parsed = profile ? lightingSchema.parse(profile) : null;
    this.values.set(key,parsed);
    try {
      const storage = this.storage ?? localStorage;
      if (parsed) storage.setItem(key,JSON.stringify({version:1,profile:parsed})); else storage.removeItem(key);
      return true;
    } catch { return false; }
  }
}
